import React from "react";
import { Helmet } from "react-helmet-async";

const DEFAULT_DESC =
  "FightFund — the U.S.-only crowdfunding platform. Fast for donors. Strict for fundraisers. Controlled before payout.";
const DEFAULT_IMAGE = `${process.env.REACT_APP_BACKEND_URL}/api/og/home.png`;

export default function Seo({ title, description, image, url }) {
  const t = title ? `${title} · FightFund` : "FightFund — Fast for donors. Strict for fundraisers.";
  const d = description || DEFAULT_DESC;
  const img = image || DEFAULT_IMAGE;
  return (
    <Helmet prioritizeSeoTags>
      <title>{t}</title>
      <meta name="description" content={d} />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="FightFund" />
      {url && <meta property="og:url" content={url} />}
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
